import React from "react";
import  Menu  from 'semantic-ui-react/dist/es/collections/Menu/Menu';


const VmoMenu = (props) => {
    return <Menu {...props} />
}
export default VmoMenu